'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;}; // Modules





// Components




// Helpers









// Styles
var _react = require('react');var _react2 = _interopRequireDefault(_react);var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);var _reactRouter = require('react-router');var _components = require('../../components');var _MainLink = require('./components/MainLink');var _MainLink2 = _interopRequireDefault(_MainLink);var _AdditionalLink = require('./components/AdditionalLink');var _AdditionalLink2 = _interopRequireDefault(_AdditionalLink);var _analyticsManager = require('../../utils/analytics/analyticsManager');var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);var _constants = require('../../constants');var _config = require('./config');var _HeaderDesktop = require('./HeaderDesktop.scss');var styles = _interopRequireWildcard(_HeaderDesktop);
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var HeaderDesktop = function HeaderDesktop(props) {
  var dropdown = void 0;
  var dropdownProperty = void 0;

  var optionTypes = (0, _constants.getOptionTypes)();

  var getDropdownRef = function getDropdownRef(ref) {
    dropdown = ref;
  };

  var getDropdownPropertyRef = function getDropdownPropertyRef(ref) {
    dropdownProperty = ref;
  };

  var getRoute = function getRoute(route, id, view) {return function () {
      if (view) {
        props.switchAccountView({ view: view });
      }

      if (id) {
        (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.headerNavigation, _analyticsConstants.eventAction.click, _analyticsConstants.eventLabel[id]);
      }

      if (route.includes('manage_properties') && props.isAgent) {
        props.setPaginationStepForAgentManage(1);
      }

      _reactRouter.browserHistory.push(route);
    };};

  var getDropdownOptions = function getDropdownOptions() {
    var options = [
    {
      name: 'editProfile',
      icon: 'user',
      displayName: props.translate('header', 'editProfile'),
      props: {
        onClick: getRoute((0, _appendLocale2.default)(props.locale, '/profile/edit'), 'editProfile', _constants.myAccountViews.MY_ACCOUNT) } },


    {
      name: 'leads',
      icon: 'leads-icon',
      displayName: props.translate('header', 'leads'),
      props: {
        onClick: getRoute((0, _appendLocale2.default)(props.locale, '/profile/leads'), 'savedSearches', _constants.myAccountViews.MY_LEADS) } },


    {
      name: 'my_projects',
      icon: 'projects',
      displayName: props.translate('header', 'my_projects'),
      props: {
        onClick: getRoute((0, _appendLocale2.default)(props.locale, '/profile/my_projects'), 'savedSearches', _constants.myAccountViews.MY_PROJECTS) } },


    {
      name: 'mySearches',
      icon: 'my-searches',
      displayName: props.translate('header', 'mySearches'),
      props: {
        onClick: getRoute((0, _appendLocale2.default)(props.locale, '/profile/searches'), 'savedSearches', _constants.myAccountViews.MY_SEARCHES) } }];




    if (props.userHasProperties) {
      options.unshift({
        name: 'manageProperties',
        icon: 'manage',
        displayName: props.translate('header', 'manageProperties'),
        props: {
          onClick: getRoute((0, _appendLocale2.default)(props.locale, '/manage_properties'), 'manageProperties') } });


    }

    return options;
  };

  var openUserAuthOverlay = function openUserAuthOverlay(type) {
    props.switchAuthModalType({
      bodyType: _constants.authenticationModalType.DEFAULT,
      selectedTab: type });

    _reactRouter.browserHistory.push((0, _appendLocale2.default)(props.locale, '/' + type));
  };

  var clickHome = function clickHome(event) {
    event.preventDefault();
    if (props.isHomePage) {
      return global.window.location.reload();
    }

    return _reactRouter.browserHistory.push((0, _appendLocale2.default)(props.locale, '/'));
  };

  var handlePublishClick = function handlePublishClick(evt) {
    var canPublish = props.publishClicked(evt);
    if (canPublish) {
      _reactRouter.browserHistory.push((0, _appendLocale2.default)(props.locale, '/publish'));
    }
  };

  var handleForeignPublishClick = function handleForeignPublishClick(evt) {
    var canPublish = props.publishClicked(evt);
    if (canPublish) {
      _reactRouter.browserHistory.push((0, _appendLocale2.default)(props.locale, '/foreign_publish'));
    }
  };

  var handleSaveDraft = function handleSaveDraft() {
    var field = props.isForeignDraft ? 'publishForeignData' : 'publishData';

    props.savePublishDraft(field);
  };

  var handleFavoritesClick = function handleFavoritesClick() {
    if (props.favoritesListIsActive) {return;}var
    route = props.routeData.route;
    var needRedirect = !optionTypes.some(function (type) {return route.includes(type);});
    var newRoute = needRedirect ? (0, _appendLocale2.default)(props.locale, '/homes/buy/fav') : route + '/fav';

    props.setFavoritesListState(true);
    getRoute(newRoute, 'favorites')();
  };

  var handleClick = function handleClick(evt) {
    var linkId = (0, _get2.default)(evt, 'currentTarget.dataset.linkId', '');
    var id = linkId.split('_').pop();
    (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.headerNavigation, _analyticsConstants.eventAction.click, _analyticsConstants.eventLabel[id]);
    props.setFavoritesListState(false);
  };

  var openLogin = function openLogin() {
    (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.headerNavigation, _analyticsConstants.eventAction.click, _analyticsConstants.eventLabel.login);
    openUserAuthOverlay(_constants.userAuthenticationPageTabs.SIGN_IN);
  };

  var openRegister = function openRegister() {
    (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.headerNavigation, _analyticsConstants.eventAction.click, _analyticsConstants.eventLabel.newAccount);
    openUserAuthOverlay(_constants.userAuthenticationPageTabs.SIGN_UP);
  };

  var openDropdownProperty = function openDropdownProperty() {return dropdownProperty && dropdownProperty.click();};

  var renderPublishButton = function renderPublishButton() {var
    route = props.routeData.route;

    var foreign = (0, _get2.default)(props, 'userAuthentication.data.publish_permissions.foreign', null);
    var regular = (0, _get2.default)(props, 'userAuthentication.data.publish_permissions.regular', null);
    var isEditPage = route.includes('property/edit') ||
    route.includes('foreign_property/edit') ||
    route.includes('project/edit');

    if (props.canSavePublishDraft) {
      return (
        _react2.default.createElement('button', {
            className: styles.saveDraftButton,
            onClick: handleSaveDraft },

          props.translate('header', props.publishDraftSaved ? 'saved' : 'saveDraft')));


    }

    if (foreign && regular) {
      return (
        _react2.default.createElement(_components.MenuDropdownProperty, {
          triggerIds: ['publishPropertyButtonTitle', 'publishPropertyButton'],
          innerRef: getDropdownPropertyRef,
          translate: props.translate,
          onClick: openDropdownProperty,
          getRoute: getRoute,
          locale: props.locale,
          isDisabled: isEditPage }));


    }

    return props.isForeignPublish ?
    _react2.default.createElement(_components.PublishPropertyButton, {
      title: '' + props.translate('header', 'publishProperty'),
      theme: 'foreign',
      size: 'medium',
      onClick: handleForeignPublishClick,
      isDisabled: isEditPage }) :


    _react2.default.createElement(_components.PublishPropertyButton, {
      title: '' + props.translate('header', 'publishProperty'),
      theme: 'primary',
      size: 'medium',
      onClick: handlePublishClick,
      isDisabled: isEditPage });


  };

  var renderIconLink = function renderIconLink(name, count, clickHandler) {return (
      _react2.default.createElement('div', { className: styles.iconLink, onClick: clickHandler },
        _react2.default.createElement('i', { className: 'icon icon-' + name },
          _react2.default.createElement('i', { className: 'path1' }),
          _react2.default.createElement('i', { className: name === 'leads-icon' && count ? styles.iconLinkPath2 : 'path2' }),
          _react2.default.createElement('i', { className: 'path3' })), '\xA0',


        _react2.default.createElement('span', { className: name === 'leads-icon' && styles.spanLeads }, count || '')));};



  var renderUserPart = function renderUserPart() {
    if (!props.userIsAuthorized) {
      return (
        _react2.default.createElement('div', { className: styles.userPart },
          _react2.default.createElement('button', { onClick: openRegister },
            props.translate('header', 'newAccount')),


          _react2.default.createElement('button', { onClick: openLogin },
            props.translate('header', 'signIn'))));



    }

    var profileImage = props.profileImage ?
    _react2.default.createElement('div', { id: 'profileImage', style: { backgroundImage: 'url(' + props.profileImage + ')' } }) :
    _react2.default.createElement('span', { id: 'profileImage', className: 'icon icon-user' });

    return (
      _react2.default.createElement('div', { className: styles.profileWrapper },
        _react2.default.createElement('div', {
            id: 'profileImageWrapper',
            className: styles.profileImage,
            onClick: function onClick() {dropdown && dropdown.click();} },

          profileImage),


        _react2.default.createElement(_components.MenuDropdown, {
          triggerIds: ['profileImage', 'profileImageWrapper'],
          innerRef: getDropdownRef,
          title: props.translate('header', 'profile'),
          options: getDropdownOptions(),
          className: props.isHomePageStyles ? 'homePage' : null,
          isHomesResultPage: props.isHomesResultPage,
          numberLeads: props.numberLeads })));



  };

  return (
    _react2.default.createElement('header', { className: styles.header },
      _react2.default.createElement('div', { className: styles.additionalRow },
        _react2.default.createElement('div', { className: styles.headerAdditionalLinkWrapper },
          (0, _config.configAdditionalHeaderRow)(props.translate).map(function (config) {return (
              _react2.default.createElement(_AdditionalLink2.default, _extends({},
              config, {
                key: config.name,
                locale: props.locale,
                newPropertyLabel: '' + props.translate('iconTitles', 'newPropertyLabel'),
                onClick: handleClick })));})),



        _react2.default.createElement('div', { className: styles.userPartWrapper },
          renderUserPart(),
          _react2.default.createElement(_components.LanguageDropdown, {
            locale: props.locale,
            routeData: props.routeData }))),




      _react2.default.createElement('div', { className: styles.mainRow },
        _react2.default.createElement('div', { className: styles.mainLinks },
          _react2.default.createElement('div', { className: styles.onMapLogoWrapper },
            _react2.default.createElement(_reactRouter.Link, { to: (0, _appendLocale2.default)(props.locale, '') || '/', className: styles.logo, onClick: clickHome },
              _react2.default.createElement('img', {
                width: '112px',
                src: _constants.onMapLogoBlue,
                alt: '',
                title: '' + props.translate('header', 'onMapHomepage') }))),



          _react2.default.createElement('div', { className: styles.mainLinkWrapper },
            (0, _config.configMainHeaderRow)(props.translate).map(function (config) {return (
                _react2.default.createElement(_MainLink2.default, _extends({},
                config, {
                  translate: props.translate,
                  routeData: props.routeData,
                  locale: props.locale,
                  key: config.name,
                  onClick: handleClick })));}))),





        _react2.default.createElement('div', { className: styles.publishBlock },
          !!props.savedSearchesCount && renderIconLink(
          'header-searches',
          props.savedSearchesCount,
          getRoute((0, _appendLocale2.default)(props.locale, '/profile/searches'), 'savedSearches', _constants.myAccountViews.MY_SEARCHES)),

          renderIconLink(
          'header-favorites',
          props.favoritesCount,
          handleFavoritesClick),

          props.userAuthentication.userIsAuthorized && renderIconLink(
          'leads-icon',
          props.numberLeads,
          getRoute((0, _appendLocale2.default)(props.locale, '/profile/leads'), 'leads', _constants.myAccountViews.MY_LEADS)),

          renderPublishButton()))));




};

HeaderDesktop.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  translate: _propTypes2.default.func,
  userIsAuthorized: _propTypes2.default.bool,
  openAuthenticationModal: _propTypes2.default.func,
  profileImage: _propTypes2.default.string,
  userHasProperties: _propTypes2.default.bool,
  isAgent: _propTypes2.default.bool,
  publishClicked: _propTypes2.default.func.isRequired,
  isHomePage: _propTypes2.default.bool,
  isHomePageStyles: _propTypes2.default.bool,
  isHomesResultPage: _propTypes2.default.bool,
  routeData: _propTypes2.default.object,
  switchAccountView: _propTypes2.default.func,
  setPaginationStepForAgentManage: _propTypes2.default.func,
  setFavoritesListState: _propTypes2.default.func,
  favoritesCount: _propTypes2.default.number,
  savedSearchesCount: _propTypes2.default.number,
  numberLeads: _propTypes2.default.number,
  userAuthentication: _propTypes2.default.object,
  favoritesListIsActive: _propTypes2.default.bool,
  savePublishDraft: _propTypes2.default.func,
  canSavePublishDraft: _propTypes2.default.bool,
  publishDraftSaved: _propTypes2.default.bool,
  isForeignPublish: _propTypes2.default.bool,
  isForeignDraft: _propTypes2.default.bool,
  switchAuthModalType: _propTypes2.default.func };exports.default =


HeaderDesktop;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderDesktop/HeaderDesktop.js
// module id = 2670
// module chunks = 0